import Api from '@/utils/api'
import BasicConfig from '@/config/basic'

// =================== java API ===================
// 获取门店列表（/common/store）
export function getJStoreList (query) {
  return Api.get(`${BasicConfig.jDomain}/common/store`, { params: { ...query, axiosType: 'java' } })
}

// 获取枚举选项列表（/common/enum/options），按 key 分桶（如 NotifyCategory、NotificationChannel）
export function getEnumOptions (query) {
  return Api.get(`${BasicConfig.jDomain}/common/enum/options`, { params: { ...query, axiosType: 'java' } })
}

// 获取字典选项列表（/common/dict/options），按 typeCode 分桶（如 nursing_type）
export function getDictOptions (query) {
  return Api.get(`${BasicConfig.jDomain}/common/dict/options`, { params: { ...query, axiosType: 'java' } })
}

// 获取职位列表（/common/position）
export function getJPositionList (query) {
  return Api.get(`${BasicConfig.jDomain}/common/position`, { params: { ...query, axiosType: 'java' } })
}

// 获取部门列表（/common/department）
export function getJDepartmentList (query) {
  return Api.get(`${BasicConfig.jDomain}/common/department`, { params: { ...query, axiosType: 'java' } })
}




// =================== python API ===================
// 获取门店列表
export function getStoreList (query) {
  return Api.get('/api/get_store', { params: { ...query, axiosType: 'python' } })
}

// 获取房间类型
export function getRoomType (query) {
  return Api.get('/api/get_room_map', { params: { ...query, axiosType: 'python' } })
}

// 获取员工列表
export function getStaffList (query) {
  return Api.get('/api/get_staff', {
    params: { ...query, axiosType: 'python' }
  })
}


// 根据IP获取地理位置
export function getLocationByIP () {
  return Api.get('/api/get_location_by_ip', { params: { axiosType: 'python' } })
}

// 根据经纬度获取地理位置信息
export function getLocationByCoordinates (lat, lon) {
  return Api.get('/api/get_location_by_coords', { params: { lat, lon, axiosType: 'python' } })
}